export default __webpack_public_path__ + "static/media/fourth.63f9e11d.svg";